import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Certificate } from '@shared/models';

@Component({
  selector: 'mojo-candidate-resume-certifications',
  templateUrl: './candidate-resume-certifications.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateResumeCertificationsComponent {
  @Input()
  certifications: Certificate[];

  @Input()
  keywords: string[];

  track = (index: number, item: Certificate) => item.name;
}
